<div class="content">
  <ng-scrollbar>
    @for (event of entries$ | async; track event) {
      <div class="event">
        @let eventKind = event.event;

        <div class="header">
          @if (event.author) {
            <span class="actor">
              &nbsp;
              @if (
                (event.author | getOrganizationMemberName | async) ===
                'organizationMemberYou'
              ) {
                <span forceContext="orderManagement" translate
                  >organizationMemberYou</span
                >
              } @else {
                <ng-template [ngTemplateOutlet]="actorName"></ng-template>
              }
              <ng-template #actorName
                ><span>{{
                  event.author | getOrganizationMemberName | async
                }}</span></ng-template
              >
            </span>
          }
          <div
            [matTooltip]="
              event.time * 1000
                | dateTimeFromMilliseconds
                | dateTimeToJsDate
                | date: 'medium'
            "
          >
            {{ event.time | relativeTime | async }}
          </div>
        </div>

        @switch (eventKind) {
          @case ('PrivateSessionVisitedByClient') {
            <app-privateesion-visited-by-client
              [details]="event.details"
            ></app-privateesion-visited-by-client>
          }
          @case ('PublicSessionCreated') {
            <app-public-session-created
              [details]="event.details"
            ></app-public-session-created>
          }
          @case ('PublicSessionDeactivated') {
            <app-public-session-deactivated
              [details]="event.details"
            ></app-public-session-deactivated>
          }
          @case ('SessionsStats') {
            <app-session-stats [details]="event.details"></app-session-stats>
          }
          @case ('ZalamoWelcomeMessage') {
            <app-zalamo-welcome-message
              [details]="event.details"
            ></app-zalamo-welcome-message>
          }
          @case ('ZalamoUpdate') {
            <app-zalamo-update [details]="event.details"></app-zalamo-update>
          }
          @case ('LookBookCreated') {
            <app-look-book-created
              [details]="event.details"
            ></app-look-book-created>
          }
          @case ('LookBookOrderPlaced') {
            <app-look-book-order-placed
              [details]="event.details"
            ></app-look-book-order-placed>
          }

          @case ('LookBookVisitedByClient') {
            <app-look-book-visited-by-client
              [details]="event.details"
            ></app-look-book-visited-by-client>
          }
          @case ('OrderPlaced') {
            <app-photographer-wall-order-placed
              [details]="event.details"
            ></app-photographer-wall-order-placed>
          }
          @case ('PrivateSessionCreated') {
            <app-private-session-created
              [details]="event.details"
            ></app-private-session-created>
          }
        }

        @if (
          eventKind !== 'PrivateSessionVisitedByClient' &&
          eventKind !== 'PublicSessionCreated' &&
          eventKind !== 'PublicSessionDeactivated' &&
          eventKind !== 'SessionsStats' &&
          eventKind !== 'ZalamoWelcomeMessage' &&
          eventKind !== 'ZalamoUpdate' &&
          eventKind !== 'LookBookCreated' &&
          eventKind !== 'LookBookOrderPlaced' &&
          eventKind !== 'LookBookVisitedByClient' &&
          eventKind !== 'OrderPlaced' &&
          eventKind !== 'PrivateSessionCreated'
        ) {
          @if (isDev) {
            <pre>{{ event | json }}</pre>
          }
        }
      </div>
    }
  </ng-scrollbar>
</div>
